module.exports = __webpack_public_path__ + "img/icon-number-five.759be1ff.svg";